export default {
  UNAUTHORIZED: 401
}
